import { BRAND } from "../constants";

export default function SuccessStep({ tier, submittedCount, maxTributes, skipToTributes }) {
  var remaining = maxTributes - submittedCount;
  var allDone = remaining <= 0;

  return (
    <div style={{ textAlign: "center", padding: "20px 0" }}>
      <div style={{
        width: "56px", height: "56px", borderRadius: "50%",
        background: BRAND.primary, margin: "0 auto 16px",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
      <h2 style={{
        fontFamily: "'Playfair Display', serif",
        fontSize: "22px", color: "#1A1A1A", margin: "0 0 12px", fontWeight: 800,
      }}>
        Thank You for Stepping Up!
      </h2>
      {!skipToTributes && (
        <p style={{ fontSize: "14px", color: "#555", margin: "0 0 6px" }}>
          {"Your $" + tier.price + " donation has been received."}
        </p>
      )}
      <p style={{ fontSize: "14px", color: "#555", margin: "0 0 6px" }}>
        {submittedCount + " tribute" + (submittedCount !== 1 ? "s" : "") + " submitted for approval."}
      </p>
      {!skipToTributes && (
        <p style={{ fontSize: "14px", color: "#555", margin: "0 0 0" }}>
          Your yard sign will be delivered soon!
        </p>
      )}
      {allDone ? (
        <p style={{ fontSize: "12px", color: "#AAA", marginTop: "16px" }}>
          {"All " + maxTributes + " tributes submitted!"}
        </p>
      ) : (
        <p style={{ fontSize: "12px", color: "#AAA", marginTop: "16px" }}>
          {"You have " + remaining + " more tribute" + (remaining !== 1 ? "s" : "") + " available. You can write them anytime by clicking Step Up again."}
        </p>
      )}
    </div>
  );
}
